
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import RouenNewsSection from './components/RouenNewsSection';
import QuickHelpSection from './components/QuickHelpSection';
import ServicesSlider from '../../components/feature/ServicesSlider';
import AutoRepairSection from './components/AutoRepairSection';
import MechanicsSection from './components/MechanicsSection';
import CommunitySection from './components/CommunitySection';
import CTASection from './components/CTASection';
import AdministrativeSection from './components/AdministrativeSection';
import JobsSection from './components/JobsSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import MarketplaceSection from './components/MarketplaceSection';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <RouenNewsSection />
      <QuickHelpSection />
      <ServicesSection />
      <MarketplaceSection />
      <StatsSection />
      <TestimonialsSection />
      <CommunitySection />
      <CTASection />
    </div>
  );
};

export default HomePage;
